/* tslint:disable */
/* eslint-disable */

import React, { FunctionComponent } from 'react';
import { ViewProps } from 'react-native';
import { Svg, GProps, Path } from 'react-native-svg';
import { getIconColor } from './helper';

interface Props extends GProps, ViewProps {
  size?: number;
  color?: string | string[];
}

let ClusterO: FunctionComponent<Props> = ({ size, color, ...rest }) => {
  return (
    <Svg viewBox="0 0 1024 1024" width={size} height={size} {...rest}>
      <Path
        d="M455.110656 170.667008v113.77664h113.778688v-113.77664H455.110656z m0-56.889344h113.778688c31.418368 0 56.88832 25.469952 56.88832 56.889344v113.77664c0 31.419392-25.469952 56.889344-56.88832 56.889344H455.110656c-31.418368 0-56.88832-25.469952-56.88832-56.88832V170.667008c0-31.419392 25.469952-56.889344 56.88832-56.889344zM113.777664 739.555328v113.777664h113.777664v-113.77664h-113.77664z m0-56.88832h113.777664c31.419392 0 56.889344 25.469952 56.889344 56.88832v113.777664c0 31.419392-25.469952 56.889344-56.889344 56.889344h-113.77664c-31.419392 0-56.889344-25.469952-56.889344-56.889344v-113.77664c0-31.419392 25.469952-56.889344 56.88832-56.889344zM455.110656 739.555328v113.777664h113.778688v-113.77664H455.110656z m0-56.88832h113.778688c31.418368 0 56.88832 25.469952 56.88832 56.88832v113.777664c0 31.419392-25.469952 56.889344-56.88832 56.889344H455.110656c-31.418368 0-56.88832-25.469952-56.88832-56.889344v-113.77664c0-31.419392 25.469952-56.889344 56.88832-56.889344zM796.444672 739.555328v113.777664h113.77664v-113.77664h-113.77664z m0-56.88832h113.77664c31.419392 0 56.889344 25.469952 56.889344 56.88832v113.777664c0 31.419392-25.469952 56.889344-56.88832 56.889344H796.444672c-31.419392 0-56.889344-25.469952-56.889344-56.889344v-113.77664c0-31.419392 25.469952-56.889344 56.889344-56.889344z"
        fill={getIconColor(color, 0, '#333333')}
      />
      <Path
        d="M160.057344 682.667008c45.197312-139.911168 171.505664-243.360768 323.497984-254.922752V284.444672h56.889344v143.299584c151.99232 11.561984 278.300672 115.011584 323.497984 254.922752h-60.383232c-42.225664-108.12416-142.861312-186.998784-263.114752-197.8368v197.8368h-56.889344v-197.8368c-120.25344 10.838016-220.889088 89.71264-263.114752 197.8368h-60.383232z"
        fill={getIconColor(color, 1, '#333333')}
      />
    </Svg>
  );
};

ClusterO.defaultProps = {
  size: 18,
};

ClusterO = React.memo ? React.memo(ClusterO) : ClusterO;

export default ClusterO;
